import { ImportConfigurationRepository } from '../data/import-configuration-repository';
import { SheetMappingDeleteResponse } from '../types/import-configuration-types';

/**
 * Use case for deleting a sheet mapping
 */
export class DeleteSheetMappingUseCase {
  constructor(private readonly repository: ImportConfigurationRepository) {}

  async execute(mappingId: number): Promise<SheetMappingDeleteResponse> {
    return this.repository.deleteSheetMapping(mappingId);
  }
}
